// API Base URL Configuration
const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "production";
export const API_BASE_URL =
  APP_ENVIRONMENT === "production"
    ? "https://streak-spark-api.fly.dev"
    : "http://localhost:3001";
